import { IconProps } from ".";
import Icon from "./assets/chevron_up_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChevronUp(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
